import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {Observable} from 'rxjs';
import {
  IMobilization,
  ILongTermLeaveDropdowns,
  ILongTermLeaveResponse,
} from '../../interfaces/long-term-leave.interface';
import {ISabbatical} from '../../interfaces/long-term-leave.interface';
// import {IContactPerson} from 'src/app/interfaces/personal-data.interface';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LongTermLeaveService {
  private urlEmployee = environment.API + 'api/v1/Employee/';

  constructor(private http: HttpClient) {}

  getDropdowns(): Observable<ILongTermLeaveDropdowns> {
    return this.http.get<ILongTermLeaveDropdowns>(
      `${this.urlEmployee}general/longTermLeaves/editMode`
    );
  }

  public createMobilization(
    body: IMobilization
  ): Observable<ILongTermLeaveResponse> {
    return this.http.post<ILongTermLeaveResponse>(
      `${this.urlEmployee}general/mobilizationPeriod`,
      body
    );
  }

  public updateMobilization(
    body: IMobilization
  ): Observable<ILongTermLeaveResponse> {
    return this.http.put<ILongTermLeaveResponse>(
      `${this.urlEmployee}general/mobilizationPeriod`,
      body
    );
  }

  public addSabbatical(body: ISabbatical): Observable<void> {
    return this.http.post<void>(`${this.urlEmployee}general/sabbatical`, body);
  }

  public updateSabbatical(body: ISabbatical): Observable<void> {
    return this.http.put<void>(`${this.urlEmployee}general/sabbatical`, body);
  }

  public deleteSabbatical(id: number): Observable<void> {
    return this.http.delete<void>(
      `${this.urlEmployee}general/sabbatical/${id}`
    );
  }
  public deleteMobilization(id: number): Observable<void> {
    return this.http.delete<void>(
      `${this.urlEmployee}general/mobilizationPeriod/${id}`
    );
  }
}
